import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import Wrapper from "./loanForm.styles";
import ErrorModal from "../components/errorModal/errorModal";
import {useDispatch} from "react-redux";
import actions from "@redux/loanForm/actions";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "../../../route.constants";
import { FORM_ID } from "../../../constants/commonConstants";

export function withLoanForm(WrappedComponent) {
  return ({ ...props }) => {
    const { loanFormError } = useSelector(state => state.loanForm);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [showErrorModal, setShowErrorModal] = useState(false);
    
    useEffect(() => {
      if (loanFormError)
        setShowErrorModal(true)
    }, [loanFormError]);

    const restartFormHandler = () => {
      dispatch(actions.resetForm())
      navigate(PUBLIC_ROUTE.INDEX);
    }
    
    return (
      <Wrapper>
        <form
          id={FORM_ID}
          noValidate
          autoComplete="off"
          className="register-form"
          onSubmit={(event) => {
            event.preventDefault();
            props.handleSubmit();
          }}
        >
          <ErrorModal
            visible={showErrorModal}
            stay={() => setShowErrorModal(false)}
            restart={() => restartFormHandler()}
            {...props}
          />
          <WrappedComponent {...props} />
          <input type="submit" style={{display: "none"}}></input>
        </form>
      </Wrapper>
    );
  };
}

export default withLoanForm;